import { Tabs, TabsContent, TabsList, TabsTrigger } from '@/components/ui/tabs';
import { Territory } from '@/types/territories/territory.type';

import { CandidatesTab } from './CandidatesTab';
import { DemographicSection } from './DemographicSection';

interface TerritoryDetailViewProps {
  territory: Territory;
}

export const TerritoryDetailView = ({
  territory,
}: TerritoryDetailViewProps) => {
  return (
    <div className="bg-muted p-4">
      <div className="bg-white p-4">
        <Tabs defaultValue="candidates">
          <TabsList className="mb-4 w-full md:w-fit">
            <TabsTrigger value="candidates" className="w-full">
              Candidates
            </TabsTrigger>
            <TabsTrigger value="territory-demographics" className="w-full">
              Territory Demographics
            </TabsTrigger>
          </TabsList>
          <TabsContent value="candidates">
            <CandidatesTab territory={territory} />
          </TabsContent>
          <TabsContent value="territory-demographics">
            <DemographicSection territory={territory} />
          </TabsContent>
        </Tabs>
      </div>
    </div>
  );
};
